/**
 * Device ID utility for anonymous user tracking
 * Generates and persists a UUID for personalized recommendations
 */

const DEVICE_ID_KEY = 'x-device-id';

/**
 * Get or generate a device ID for anonymous user tracking.
 * The device ID is persisted in localStorage and used to track
 * browsing history for personalized product recommendations.
 * 
 * @returns The device ID string, or empty string if running on server
 */
export function getDeviceId(): string {
    if (typeof window === 'undefined') {
        return '';
    }

    let deviceId = localStorage.getItem(DEVICE_ID_KEY);

    if (!deviceId) {
        deviceId = crypto.randomUUID();
        localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }

    return deviceId;
}
